(function () {
  // v3 hard-kill: Fanny — NO auto move. Only user drag/dot tap may change slides.
  // v2 bug: time-window after tap treated autoplay as user-driven.
  if (window.__myalephPdpGalleryEnhance === 3) return;
  window.__myalephPdpGalleryEnhance = 3;

  var MQ = window.matchMedia('(max-width: 767px)');

  function getFlkty(el) {
    if (!el) return null;
    if (window.Flickity && typeof Flickity.data === 'function') {
      return Flickity.data(el);
    }
    return el.flickity || null;
  }

  function killPlayer(flkty) {
    if (!flkty) return;
    try {
      if (flkty.options) flkty.options.autoPlay = false;
      if (flkty.player) {
        try {
          if (flkty.player.options) flkty.player.options.autoPlay = false;
          flkty.player.stop && flkty.player.stop();
          flkty.player.clear && flkty.player.clear();
        } catch (e0) {}
      }
      if (typeof flkty.stopPlayer === 'function') flkty.stopPlayer();
      if (typeof flkty.pausePlayer === 'function') flkty.pausePlayer();
      flkty.playPlayer = function () {};
      if (typeof flkty.unpausePlayer === 'function') {
        flkty.unpausePlayer = function () {};
      }
    } catch (e) {}
  }

  function enhance(el) {
    if (!MQ.matches || !el) return;
    var flkty = getFlkty(el);
    if (!flkty) return;

    // Always re-kill even if already bound
    killPlayer(flkty);

    if (el.dataset.myalephGalleryBound === '3') return;
    el.dataset.myalephGalleryBound = '3';

    var lockedIndex = flkty.selectedIndex;
    var allowSelect = false; // true only for our dot handler
    var dragging = false;
    var snapping = false;

    function snapBack() {
      if (snapping) return;
      if (flkty.selectedIndex === lockedIndex) return;
      snapping = true;
      try {
        flkty.select(lockedIndex, false, true);
      } catch (e2) {}
      snapping = false;
      killPlayer(flkty);
    }

    try {
      flkty.on('dragStart', function () {
        dragging = true;
        killPlayer(flkty);
      });
      flkty.on('dragEnd', function () {
        dragging = false;
        lockedIndex = flkty.selectedIndex;
        killPlayer(flkty);
      });
      flkty.on('select', function () {
        killPlayer(flkty);
        if (snapping) return;
        if (allowSelect || dragging) {
          lockedIndex = flkty.selectedIndex;
          return;
        }
        // Non-user advance (autoplay / theme) — revert
        snapBack();
      });
      flkty.on('settle', function () {
        killPlayer(flkty);
        if (!allowSelect && !dragging && flkty.selectedIndex !== lockedIndex) {
          snapBack();
        }
      });
    } catch (e3) {}

    function bindDots() {
      var dots = el.querySelectorAll(
        '.flickity-page-dots .dot, .flickity-page-dots .flickity-page-dot'
      );
      dots.forEach(function (dot, idx) {
        if (dot.dataset.myalephTapBound === '3') return;
        dot.dataset.myalephTapBound = '3';
        dot.addEventListener(
          'click',
          function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            allowSelect = true;
            lockedIndex = idx;
            try {
              flkty.select(idx);
            } catch (e4) {}
            allowSelect = false;
            killPlayer(flkty);
          },
          true
        );
      });
    }
    bindDots();

    if (!el._myalephKillTimer) {
      el._myalephKillTimer = window.setInterval(function () {
        if (!MQ.matches) return;
        var f = getFlkty(el);
        killPlayer(f);
        bindDots();
        if (f && !dragging && !allowSelect && f.selectedIndex !== lockedIndex) {
          try {
            f.select(lockedIndex, false, true);
          } catch (e5) {}
        }
      }, 300);
    }
  }

  function scan() {
    if (!MQ.matches) return;
    document
      .querySelectorAll('[data-product-slideshow], .product__grid.flickity-enabled')
      .forEach(enhance);
  }

  function boot() {
    scan();
    var n = 0;
    var id = window.setInterval(function () {
      scan();
      if (++n > 50) window.clearInterval(id);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('load', scan);
})();
